// Lyd når det kommer et nytt varsel (Varsling). Valget lagres per maskin i
// localStorage og er av som standard, fordi én av maskinene også spiller musikk.
// Lyden lages i nettleseren (Web Audio), så det trengs ingen lydfil.

const PA_KEY = "varselLyd";
const SIST_HORT_KEY = "varselLydSistHort";
const VOLUM_KEY = "varselLydVolum";
export const VOLUM_STANDARD = 50; // 50 % = lyden slik den var før volumknappen kom
export const VARSEL_LYD_ENDRET = "varselLydEndret";

export function varselLydPa() {
  try { return localStorage.getItem(PA_KEY) === "1"; } catch { return false; }
}

export function settVarselLyd(pa) {
  try {
    if (pa) localStorage.setItem(PA_KEY, "1");
    else localStorage.removeItem(PA_KEY);
    // Nytt utgangspunkt, så varsler fra mens lyden var av ikke gir lyd.
    localStorage.removeItem(SIST_HORT_KEY);
  } catch { /* ignorer */ }
  window.dispatchEvent(new Event(VARSEL_LYD_ENDRET));
}

// Volum i prosent (5–100), lagret per maskin som av/på-valget.
export function varselLydVolum() {
  let v = NaN;
  try { v = Number(localStorage.getItem(VOLUM_KEY)); } catch { /* ignorer */ }
  return Number.isFinite(v) && v >= 5 && v <= 100 ? v : VOLUM_STANDARD;
}

export function settVarselLydVolum(v) {
  const n = Math.min(100, Math.max(5, Math.round(Number(v) || VOLUM_STANDARD)));
  try { localStorage.setItem(VOLUM_KEY, String(n)); } catch { /* ignorer */ }
}

let ctx = null;
function hentCtx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

// Nettleseren slipper ikke lyd ut før noen har klikket på siden. Etter en
// omlasting låses lyden opp ved første klikk eller tastetrykk.
if (typeof window !== "undefined") {
  const lasOpp = () => {
    if (!varselLydPa()) return;
    const c = hentCtx();
    if (c && c.state === "suspended") c.resume().catch(() => {});
  };
  window.addEventListener("pointerdown", lasOpp, { passive: true });
  window.addEventListener("keydown", lasOpp);
}

// Én myk klokketone: grunntone og en svak overtone som klinger ut.
function tone(c, frekvens, start, styrke) {
  const gain = c.createGain();
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(styrke, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 1.6);
  gain.connect(c.destination);
  for (const [mult, andel] of [[1, 1], [2.76, 0.12]]) {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = "sine";
    osc.frequency.value = frekvens * mult;
    g.gain.value = andel;
    osc.connect(g).connect(gain);
    osc.start(start);
    osc.stop(start + 1.7);
  }
}

export function spillVarselLyd() {
  const c = hentCtx();
  if (!c) return;
  const spill = () => {
    const t = c.currentTime + 0.02;
    const faktor = varselLydVolum() / VOLUM_STANDARD;
    tone(c, 1046.5, t, 0.18 * faktor); // C6
    tone(c, 784, t + 0.2, 0.15 * faktor); // G5
  };
  if (c.state === "suspended") c.resume().then(spill).catch(() => {});
  else spill();
}

// Sier om varslene inneholder noe nyere enn det som sist ga lyd. Tidspunktet
// lagres i localStorage, så flere faner på samme maskin ikke spiller hver sin lyd.
// Første gang (ingen lagret verdi) settes bare utgangspunktet, uten lyd.
export function nyttVarselSidenSist(items) {
  const nyeste = (items || [])
    .filter((i) => i.unreadCount > 0 && i.lastMessage?.createdAt)
    .reduce((maks, i) => Math.max(maks, new Date(i.lastMessage.createdAt).getTime() || 0), 0);
  let sist = 0;
  try { sist = Number(localStorage.getItem(SIST_HORT_KEY)) || 0; } catch { /* ignorer */ }
  if (nyeste <= sist) return false;
  try { localStorage.setItem(SIST_HORT_KEY, String(nyeste)); } catch { /* ignorer */ }
  return sist > 0;
}
